var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_497_2880)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.83268 4.16683V1.66683C5.83268 1.44582 5.92048 1.23385 6.07676 1.07757C6.23304 0.921293 6.445 0.833496 6.66602 0.833496H13.3327C13.5537 0.833496 13.7657 0.921293 13.9219 1.07757C14.0782 1.23385 14.166 1.44582 14.166 1.66683V4.16683H17.4993C17.7204 4.16683 17.9323 4.25463 18.0886 4.41091C18.2449 4.56719 18.3327 4.77915 18.3327 5.00016V16.6668C18.3327 16.8878 18.2449 17.0998 18.0886 17.2561C17.9323 17.4124 17.7204 17.5002 17.4993 17.5002H2.49935C2.27834 17.5002 2.06637 17.4124 1.91009 17.2561C1.75381 17.0998 1.66602 16.8878 1.66602 16.6668V5.00016C1.66602 4.77915 1.75381 4.56719 1.91009 4.41091C2.06637 4.25463 2.27834 4.16683 2.49935 4.16683H5.83268ZM16.666 10.8335H3.33268V15.8335H16.666V10.8335ZM16.666 5.8335H3.33268V9.16683H5.83268V7.50016H7.49935V9.16683H12.4993V7.50016H14.166V9.16683H16.666V5.8335ZM7.49935 2.50016V4.16683H12.4993V2.50016H7.49935Z",
    fill: "#EEAC00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_497_2880"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFull);
export default __webpack_public_path__ + "static/media/full.fff2a050dc54c9d2a1e61bcbf0b0d070.svg";
export { ForwardRef as ReactComponent };